import { render, staticRenderFns } from "./bk.vue?vue&type=template&id=69f8620b"
import script from "./bk.vue?vue&type=script&lang=js"
export * from "./bk.vue?vue&type=script&lang=js"
import style0 from "./bk.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/bk.vue
// module id = dihd
// module chunks = 0